export const CUSTOMER_REVIEWS = {
  RECOMMENDED_BY_FANS: "Highly recommended by {{percentage}}%",
  USER_RATING_FOUR_OR_MORE:
    "{{percentage}}% of users rated this org 4 stars or more",
  CUSTOMER_REVIEWS: "Customer reviews",
  RESPONSE_FROM_ORGANIZER: "Response from organizer",
};
